import { Link } from "react-router-dom"
import Paginator from "../../components/Paginator"
import Search from "../../components/Search"
import StandardLayout from "../../components/StandardLayout"
import { removeEmpties } from "../../helper"
import { useQsFilters } from "../../hooks/useFilters"
import { useContenitoriList } from "../../hooks/useContenitore"

const initFilters = (params: URLSearchParams) => ({
  page: Number(params.get("page") ?? 1),
  search: params.get("search") ?? "",
  tipo: params.get("tipo") ?? "",
})

const Contenitori = () => {
  const { filters, uiFilters, setFilters, setFiltersDebounced } = useQsFilters(initFilters)

  const { data: contenitori } = useContenitoriList(
    removeEmpties({
      search: filters.search,
      page: String(filters.page),
      tipo: filters.tipo,
    })
  )

  return (
    <StandardLayout>
      <div className="sticky-header bg-light p-3 shadow-sm">
        <div className="d-flex justify-content-between">
          <div>
          <div className="page-title">
              <Link to="/dati-base">{"Dati di base"}</Link>
              {filters?.tipo ? (
                <>
                  {" / "}
                  <Link to={`/dati-base/contenitori/list`} state={{ filter: undefined }}>
                    {"Contenitori"}
                  </Link>
                  {` - ${filters?.tipo ?? ""}`}
                </>
              ) : (
                <>{" / Contenitori"}</>
              )}
            </div>
          </div>
          <Search
            value={uiFilters.search}
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              setFiltersDebounced({ search: e.currentTarget.value, page: 1 })
            }
          />
        </div>
      </div>

      <div className="p-3">
        {contenitori ? (
          <div className="">
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>{"Loc ref."}</th>
                  <th>{"Smart bin"}</th>
                  <th>{"Dentro a"}</th>
                </tr>
              </thead>
              <tbody>
                {contenitori.results.map((area) => (
                  <tr key={area.loc_ref}>
                    <td>{area.loc_ref}</td>
                    <td>{area.smart_bin}</td>
                    <td>{area.dentro_a}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </div>

      <div className="sticky-footer bg-light border-top">
        <Paginator
          count={contenitori?.count ?? 0}
          currentPage={uiFilters.page}
          goToPage={(page) => setFilters({ page })}
        />
      </div>
    </StandardLayout>
  )
}

export default Contenitori
